import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/templates/assembly-templates");
export const getIdPath = returnPath("/templates/assembly-templates/:id");
